export const ImportClientsPrioritairesSteps = {
    WaitFile: 0,
    LoadFile: 1,
    SetClientsPrioritaires: 2,
    WaitImport: 3,
    ImportResult: 4
};
